import {ConfigContext} from "../../../__snowpack__/pkg/antd/es/config-provider.js";
import UploadList from "../../../__snowpack__/pkg/antd/es/upload/UploadList.js";
import React, {useContext} from "../../../__snowpack__/pkg/react.js";
import {SortableContainer, SortableElement} from "../../../__snowpack__/pkg/react-sortable-hoc.js";
export const SortableList = SortableContainer((props) => {
  const {items, onRemove, uploadProps} = props;
  const {draggable = false, readonly} = uploadProps;
  return /* @__PURE__ */ React.createElement("span", {
    className: "gn-upload-sortable-list"
  }, items?.map((item, index) => /* @__PURE__ */ React.createElement(SortableItem, {
    key: `${item.uid}`,
    item,
    items,
    index,
    disabled: !draggable || readonly,
    uploadProps,
    onRemove
  })));
});
const SortableItem = SortableElement((props) => {
  const {items, item, onRemove, uploadProps} = props;
  const context = useContext(ConfigContext);
  const {itemWrapperRender} = uploadProps;
  const itemNode = /* @__PURE__ */ React.createElement(UploadList, {
    locale: context.locale?.Upload ?? {},
    showDownloadIcon: false,
    showRemoveIcon: !uploadProps.readonly,
    listType: uploadProps.listType,
    onRemove,
    items: [item],
    itemRender: uploadProps.itemRender && ((originNode) => uploadProps.itemRender?.(originNode, item, items))
  });
  return itemWrapperRender ? itemWrapperRender(itemNode, item, items) : itemNode;
});
